import React from "react";
import { Button } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormCheck } from "go-form";
import { ReactComponent as AddSVG } from "go-core/images/svg/actions/add.svg";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { ApplicationApi } from "../../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../../services/Api/api";
import { AppState } from "../../../utils/types";
import { getPriceListIdDefaultValue } from "../../../utils/utils";
import GoOrderMenuForm from "./GoOrderMenuForm";

interface Props {
	form: UseFormReturn<ApplicationApi>;
	updatedConfig: Record<string, any> | undefined;
	setUpdatedConfig: (config: Record<string, any> | undefined) => void;
	appState: AppState;
}

const GoOrderSendingMenuForm = ({ form, updatedConfig, setUpdatedConfig, appState }: Props) => {
	const { t } = useTranslation();
	const {
		formState: { errors },
		control,
		register,
		setValue,
		watch,
	} = form;
	const watchedMenus: Record<string, any>[] = watch("settings.menu_infos");
	const priceListIdDefaultValues = getPriceListIdDefaultValue(appState, updatedConfig);

	const searchPriceList = (search: string, params: Record<string, any>, options?: Record<string, any>) => {
		return api.organization().getPriceListsSearchSelect(search, params, undefined, {
			cancelToken: options?.token,
		});
	};

	const handleSendMenuBasedOnPriceListClickHandler = () => setValue("settings.price_list_id", "");

	const handleAddMenu = () => {
		const copiedMenus = [...watchedMenus];
		copiedMenus.push({
			menu_id: undefined,
			availability_id: undefined,
			order_types: [],
		});
		setValue("settings.menu_infos", copiedMenus);
	};

	const isAddButtonDisabled = () => {
		if (watchedMenus.length === 0) return false;

		const lastMenu = watchedMenus[watchedMenus.length - 1];

		if (!lastMenu?.menu_id || !lastMenu?.order_types || lastMenu?.order_types?.length === 0) return true;

		return false;
	};

	return (
		<>
			<div className="my-3">
				<div className="d-flex align-items-center justify-content-between w-100">
					<h6>{t("modules.app.action.menu_send.title")}</h6>
					<Button
						variant="light"
						className="add-menu-btn"
						onClick={handleAddMenu}
						disabled={isAddButtonDisabled()}
					>
						<AddSVG />
					</Button>
				</div>
				{watchedMenus.map((menuInfo, index) => {
					return (
						<div className={index === 0 ? "mt-2" : "mt-0"} key={JSON.stringify(menuInfo)}>
							<GoOrderMenuForm
								index={index}
								form={form}
								updatedConfig={updatedConfig}
								setUpdatedConfig={setUpdatedConfig}
							/>
						</div>
					);
				})}
				<FormCheck
					type="switch"
					register={register}
					label={t("modules.app.field.send_menu_based_on_price_list.title")}
					name="settings.send_menu_based_on_price_list"
					errors={errors}
					onClick={handleSendMenuBasedOnPriceListClickHandler}
					help={t("modules.app.field.send_menu_based_on_price_list.help_text.title")}
				/>
				<FormSelectGroup
					name="settings.price_list_id"
					getOptionLabel={(option) => option.label}
					getOptionValue={(option) => option.id}
					loadOptions={searchPriceList}
					label={t("common.word.price_list")}
					errors={errors}
					control={control}
					data-testid="settings.price_list_id"
					isMulti={watch("settings.send_menu_based_on_price_list")}
					defaultValue={priceListIdDefaultValues}
					help={t("modules.app.field.price_list_id.help_text.title")}
				/>
			</div>
			<hr />
		</>
	);
};

export default GoOrderSendingMenuForm;
